export const FLAG_GETTING_MAINTENANCE_CHECKLISTS =
  'FLAG_GETTING_MAINTENANCE_CHECKLISTS';
export const GET_MAINTENANCE_CHECKLISTS = 'GET_MAINTENANCE_CHECKLISTS';
export const CLEAR_MAINTENANCE_CHECKLISTS = 'CLEAR_MAINTENANCE_CHECKLISTS';
export const FLAG_MAINTENANCE_CHECKLIST_ACTIVITY =
  'FLAG_MAINTENANCE_CHECKLIST_ACTIVITY';
export const GET_MAINTENANCE_CHECKLIST = 'GET_MAINTENANCE_CHECKLIST';
export const CLEAR_MAINTENANCE_CHECKLIST = 'CLEAR_MAINTENANCE_CHECKLIST';
export const FLAG_GETTING_MAINTENANCE_BASIC_ACTIVITIES =
  'FLAG_GETTING_MAINTENANCE_BASIC_ACTIVITIES';
export const GET_MAINTENANCE_BASIC_ACTIVITIES =
  'GET_MAINTENANCE_BASIC_ACTIVITIES';
export const CLEAR_MAINTENANCE_BASIC_ACTIVITIES =
  'CLEAR_MAINTENANCE_BASIC_ACTIVITIES';
